import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const SandboxLink = () => {
  const { surveyId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!surveyId){
        navigate('/simulator');
        return;
    }
    // Redirect to the actual share page
    navigate(`/simulator/${surveyId}`);
  }, []);

  return null;
};

export default SandboxLink;
